import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Reset the scroll position to the top on every route change. Single-page nav
// keeps the previous page's scroll offset, which made some pages open partway
// down. Renders nothing.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
